import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.deviceName = ''
      this.deviceId = ''
      this.phone = ''
      this.address = ''
    }
  }
}
export default searchFrom
